// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w5HV","field":"styles_field__2ZCeK","fieldCol":"styles_fieldCol__2tBvp","diffCol":"styles_diffCol__1u1e5","diff":"styles_diff__eJGya"};